import { type ComponentType, createContext, type MouseEventHandler, type ReactNode, useContext } from 'react';

export interface RouterLinkProps {
  /** An in-app href: a path, optionally with a query string. */
  to: string;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  children?: ReactNode;
  'data-tour-id'?: string;
}

export type RouterLinkComponent = ComponentType<RouterLinkProps>;

const AnchorLink: RouterLinkComponent = ({ to, ...props }) => <a href={to} {...props} />;

/**
 * The in-app link shared components render. Each app supplies its router's link once, at its root,
 * through `RouterLinkProvider`; without one the link is a plain anchor, a full page load.
 */
const RouterLinkContext = createContext<RouterLinkComponent>(AnchorLink);

export const RouterLinkProvider = RouterLinkContext.Provider;

export const useRouterLink = (): RouterLinkComponent => useContext(RouterLinkContext);
